import React, { useEffect, useRef, useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/CareGiverNew.css";
import { profile1, profile2 } from "../../Constant";
import { Link, useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import config from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHeart,
    faLocationDot,
    faStar,
} from "@fortawesome/free-solid-svg-icons";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import GoogleMapReact, { fitBounds } from "google-map-react";
import Swal from "sweetalert2";

const CareGiverNew = ({ auth, services }) => {
    const [markers, setMarkers] = useState([]);
    const [infoWindows, setInfoWindows] = useState([]);

    const mapRef = useRef();
    const Navigate = useNavigate();

    const { id } = useParams();

    const [loadingData , setLoadingData] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [service_id, setServiceId] = useState(id || "");
    const [unit, setUnit] = useState("");
    const [zip, setZip] = useState("");
    const [priceRangeFrom, setPriceRangeFrom] = useState("");
    const [priceRangeTo, setPriceRangeTo] = useState("");
    const [dateRangeFrom, setDateRangeFrom] = useState("");
    const [dateRangeTo, setDateRangeTo] = useState("");
    const [rating, setRating] = useState(0);

    const [center, setCenter] = useState({
        lat: 38.8413968,
        lng: -105.6741951,
    });
    const [zoom, setZoom] = useState(4);

    const [careGiverModal, setCareGiverModal] = useState(true);
    const [careGivers, setCareGivers] = useState([]);

    const reset = () => {
        setSelectedService(null);
        setServiceId("");
        setUnit("");
        setZip("");
        setPriceRangeFrom("");
        setPriceRangeTo("");
        setDateRangeFrom("");
        setDateRangeTo("");
        setRating(0);
    };

    const findCareGivers = async (e = null, serviceIdFilter = null) => {
        if (e) {
            e.preventDefault();
        }
        if (!serviceIdFilter && !service_id) {
            Swal.fire({
                icon: "error",
                title: "Oh Snap :(",
                html: `Something went wrong, Please check below<br/><strong>Service is Required</strong>`,
            });
            return false;
        }
        // setCareGivers([]);
        markers.forEach((marker) => {
            marker.setMap(null);
        });
        infoWindows.forEach((infoWindow) => {
            infoWindow.close();
        });
        setMarkers([]);
        setInfoWindows([]);
        setCareGiverModal(false);
        setLoadingData(true);
        const res = await config.getApi(
            config.services.allCareGiver(
                zip,
                serviceIdFilter ? serviceIdFilter : service_id,
                unit,
                priceRangeFrom,
                priceRangeTo,
                rating,
                dateRangeFrom,
                dateRangeTo
            ),
            config.bearerHeaders(auth.token)
        );
        setLoadingData(false);
        if (res) {
            console.log(res);
            let moreMarkers = [];
            let moreInfoWindows = [];
            // return console.log(res.response.data);
            setCareGivers(res.response.data);
            res.response.data.map((careGiver) => {
                if (careGiver.lat && careGiver.lng) {
                    let mar = new mapRef.current.maps_.Marker({
                        map: mapRef.current.map_,
                        position: {
                            lat: parseFloat(careGiver.lat),
                            lng: parseFloat(careGiver.lng),
                        },
                        animation: mapRef.current.maps_.Animation.DROP,
                    });
                    let infWi = new mapRef.current.maps_.InfoWindow({
                        position: {
                            lat: parseFloat(careGiver.lat),
                            lng: parseFloat(careGiver.lng),
                        },
                        content: `<strong style='color:#000' >${careGiver.full_name}</strong>`,
                    });
                    mapRef.current.maps_.event.addListener(mar, "click", () =>
                        infWi.open({ anchor: mar })
                    );
                    moreMarkers.push(mar);
                    moreInfoWindows.push(infWi);
                }
            });
            setMarkers(moreMarkers);
            setInfoWindows(moreInfoWindows);
        }
    };

    const favorite = async (careGiverId) => {
        const res = await config.postApi(
            config.services.favorite(),
            config.bearerHeaders(auth.token),
            JSON.stringify({ care_giver_id: careGiverId })
        );
        if (res) {
            findCareGivers();
        }
    };

    useEffect(() => {
        if (id) {
            findCareGivers(null,id);
            setServiceId(id);
            let selectedServicee = services.filter(
                (service) => service.id == id
            );
            if (selectedServicee.length > 0) {
                setSelectedService(selectedServicee[0]);
            }
        }
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                setCenter({
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude,
                });
            },
            (err) => {
                console.log(err);
            },
            {
                enableHighAccuracy: true,
                timeout: 20000,
            }
        );
    }, [id]);

    return (
        <>
            <Header />
            <section className="care_giver_sec">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="filtersDv">
                                <div className="heading_wrapper">
                                    <h4>Filters</h4>
                                    <p>Search your desired care giver</p>
                                </div>
                                <form method="post" onSubmit={findCareGivers}>
                                    <div className="form-group">
                                        <label htmlFor="location">
                                            Select Location
                                        </label>
                                        <input
                                            type="text"
                                            id="location"
                                            className="form-control"
                                            placeholder="Search For Location"
                                            required={true}
                                            value={zip}
                                            onChange={(e) =>
                                                setZip(e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="service_type">
                                            Service Type
                                        </label>
                                        <select
                                            required={true}
                                            id="service_type"
                                            className="form-control"
                                            value={service_id}
                                            onChange={(e) => {
                                                setServiceId(e.target.value);
                                                setCareGivers([]);
                                                setSelectedService({
                                                    id: e.target.value,
                                                    title: e.target.options[
                                                        e.target.selectedIndex
                                                    ].dataset.name,
                                                });
                                                findCareGivers(
                                                    null,
                                                    e.target.value
                                                );
                                            }}
                                        >
                                            <option value={null}>
                                                Select Service
                                            </option>
                                            {services.map((service) => (
                                                <option
                                                    key={service.id.toString()}
                                                    value={service.id}
                                                    data-name={service.title}
                                                >
                                                    {service.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="dates-range">
                                            Select Dates Range
                                        </label>
                                        <div
                                            className="input-group"
                                            id="dates-range"
                                        >
                                            <input
                                                type="date"
                                                id="date"
                                                required={true}
                                                className="form-control"
                                                value={dateRangeFrom}
                                                onChange={(e) =>
                                                    setDateRangeFrom(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            <span className="spacer">-</span>
                                            <input
                                                type="date"
                                                id="date"
                                                className="form-control"
                                                value={dateRangeTo}
                                                required={true}
                                                onChange={(e) =>
                                                    setDateRangeTo(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="time-range">
                                            Select Price Range
                                        </label>
                                        <div
                                            className="input-group"
                                            id="time-range"
                                        >
                                            <input
                                                placeholder="From"
                                                type="number"
                                                // id="time"
                                                className="form-control"
                                                value={priceRangeFrom}
                                                onChange={(e) =>
                                                    setPriceRangeFrom(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            <span className="spacer">-</span>
                                            <input
                                                placeholder="To"
                                                type="number"
                                                // id="time"
                                                className="form-control"
                                                value={priceRangeTo}
                                                onChange={(e) =>
                                                    setPriceRangeTo(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="rating_dv">
                                        <label>Rating</label>
                                        <div className="raings_stars">
                                            <div className="stars-group">
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        rating >= 1
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                    onClick={() => setRating(1)}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        rating >= 2
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                    onClick={() => setRating(2)}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        rating >= 3
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                    onClick={() => setRating(3)}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        rating >= 4
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                    onClick={() => setRating(4)}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faStar}
                                                    color={
                                                        rating >= 5
                                                            ? "#FFCC00"
                                                            : "#C8C8C8"
                                                    }
                                                    onClick={() => setRating(5)}
                                                />
                                            </div>
                                            <div className="rating_count">
                                                <span>{rating}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="buttons-group">
                                        <button
                                            className="filters_btn"
                                            type="button"
                                            onClick={reset}
                                        >
                                            Reset
                                        </button>
                                        <button className="filters_btn">
                                            Apply Filters
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="care_giver_profile">
                                <div className="heading_wrapper">
                                    <h4>
                                        {selectedService?.title} (Care Givers){" "}
                                    </h4>
                                    <p>
                                        Select your specialist based on their
                                        experience, reviews, and role.
                                    </p>
                                </div>
                                <div className="all_profiles">
                                    {
                                        loadingData?
                                            <>
                                                <i className={"fas fa-spinner fa-spin"}>Loading...</i>
                                            </>
                                            :
                                            <>
                                                {careGivers.map((careGiver) => {
                                                    let serviceFound =
                                                        careGiver.services.filter(
                                                            (service) => service
                                                            // service.service_id ==
                                                            // service_id
                                                        );
                                                    if (serviceFound.length > 0) {
                                                        return (
                                                            <div
                                                                className="profile_box"
                                                                key={careGiver.id.toString()}
                                                            >
                                                                <div className="img_box">
                                                                    <figure>
                                                                        <img
                                                                            src={config.returnImage(
                                                                                careGiver
                                                                            )}
                                                                            alt=""
                                                                        />
                                                                    </figure>
                                                                </div>
                                                                <div className="contentDv">
                                                                    <div className="header-bar">
                                                                        <Link
                                                                            to={`/single-profile/${careGiver.id}/${service_id}`}
                                                                            key={careGiver.id.toString()}
                                                                        >
                                                                            <h4>
                                                                                {
                                                                                    careGiver.full_name
                                                                                }
                                                                            </h4>
                                                                        </Link>
                                                                        <p className="rating">
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faStar
                                                                                }
                                                                                color={
                                                                                    config.starActiveColor
                                                                                }
                                                                            />
                                                                            {/* <i
                                                                    className="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i> */}
                                                                            {" " +
                                                                                careGiver.rating_by_customer}
                                                                        </p>
                                                                        <p className="reviews">
                                                                <span className="reviews_count">
                                                                    {
                                                                        careGiver.total_reviews
                                                                    }
                                                                </span>{" "}
                                                                            Review(s)
                                                                        </p>
                                                                    </div>
                                                                    <div className="address">
                                                            <span>
                                                                {(careGiver.city ||
                                                                        "") +
                                                                    ", " +
                                                                    (careGiver.state_name ||
                                                                        "") +
                                                                    " " +
                                                                    (careGiver.zip ||
                                                                        "")}
                                                            </span>
                                                                    </div>
                                                                    <div className="about_caregiver">
                                                                        <p>
                                                                            {careGiver.bio}
                                                                        </p>
                                                                    </div>
                                                                    <div className="bottom_bar">
                                                                        <div className="priceDv">
                                                                            <h4>
                                                                                $
                                                                                <span>
                                                                        {careGiver.services.map(
                                                                            (
                                                                                service
                                                                            ) => {
                                                                                if (
                                                                                    service.service_id ==
                                                                                    service_id
                                                                                ) {
                                                                                    return service.per_hour;
                                                                                }
                                                                            }
                                                                        )}
                                                                    </span>
                                                                                <sub>
                                                                                    /Hour
                                                                                </sub>
                                                                            </h4>
                                                                        </div>
                                                                        <div className="availability not_available">
                                                                            <p>
                                                                                <i
                                                                                    className="fa fa-check-circle"
                                                                                    aria-hidden="true"
                                                                                ></i>
                                                                                Calendar
                                                                                Updated{" "}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="favourite_btn">
                                                                    <label className="container">
                                                            <span className="checkmark">
                                                                <FontAwesomeIcon
                                                                    onClick={() =>
                                                                        favorite(
                                                                            careGiver.id
                                                                        )
                                                                    }
                                                                    color={
                                                                        config.primaryColor
                                                                    }
                                                                    icon={
                                                                        careGiver.favorite
                                                                            ? faHeart
                                                                            : farHeart
                                                                    }
                                                                />
                                                            </span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </>
                                    }
                                </div>
                                {/* <div className="all_results">
                                    <div className="showing_results">
                                        <p>Showing 5 of 102 </p>
                                    </div>
                                    <ul className="paginations">
                                        <li className="prev arrows">Prev</li>
                                        <div className="pagi_count">
                                            <li className="pagi active">1</li>
                                            <li className="pagi">2</li>
                                            <li className="pagi">3</li>
                                            <li className="pagi">4</li>
                                        </div>
                                        <li className="next arrows">Next</li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-4 p-0 map-mob-view">
                            <GoogleMapReact
                                ref={mapRef}
                                bootstrapURLKeys={{
                                    key: config.mapsApiKey,
                                }}
                                center={center}
                                zoom={zoom}
                                yesIWantToUseGoogleMapApiInternals
                            >
                                {/* {careGivers.map((careGiver) => {
                                    if (careGiver.lat && careGiver.lng) {
                                        return (
                                            <FontAwesomeIcon
                                                key={careGiver.id.toString()}
                                                size="3x"
                                                icon={faLocationDot}
                                                color={config.primaryColor}
                                                lat={careGiver.lat}
                                                lng={careGiver.lng}
                                            />
                                        );
                                    }
                                })} */}
                            </GoogleMapReact>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Services Popup1 Start Here --> */}
            <div
                className={`services_popup_one caregiver_popup ${
                    careGiverModal ? "show" : ""
                }`}
            >
                <div className="container">
                    <div className="popup_box">
                        <div className="heading_wrapper">
                            <h4 className="lght">Find the Best</h4>
                            <h4 className="drk">Personal Care Services</h4>
                        </div>
                        <form
                            action=""
                            method="post"
                            onSubmit={findCareGivers}
                            id="caregiver_form"
                        >
                            <p>Select Services you are looking for</p>
                            <div className="row">
                                {services.map((service) => (
                                    <div
                                        className="col-lg-4 col-md-6"
                                        key={service.id.toString()}
                                    >
                                        <div className="service_box">
                                            <label className="service-container">
                                                <input
                                                    type="radio"
                                                    value={service.id}
                                                    checked={
                                                        service_id == service.id
                                                            ? "checked"
                                                            : ""
                                                    }
                                                    onChange={(e) => {
                                                        setSelectedService(
                                                            service
                                                        );
                                                        setServiceId(
                                                            e.target.value
                                                        );
                                                    }}
                                                    name="service_id"
                                                />
                                                <span className="checkmark">
                                                    <div className="care_box">
                                                        <div className="check_icon">
                                                            <i
                                                                className="fa fa-check-circle"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </div>
                                                        <div className="img_box">
                                                            <figure>
                                                                <img
                                                                    src={
                                                                        config.assetUrl +
                                                                        "uploads/" +
                                                                        service.image
                                                                    }
                                                                    alt=""
                                                                />
                                                            </figure>
                                                        </div>
                                                        <div className="title">
                                                            <h5>
                                                                {service.title}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="form-group">
                                <label>Enter Zip</label>
                                <input
                                    className="form-control"
                                    placeholder="Enter Zip Code"
                                    value={zip}
                                    onChange={(e) => setZip(e.target.value)}
                                />
                            </div>
                            {/* <div className="form-group">
                                <label>
                                    How often do you need this service?
                                </label>
                                <div className="input_group">
                                    <label
                                        className="how_often_container"
                                        htmlFor="hourlyUnit"
                                    >
                                        <input
                                            type="radio"
                                            id="hourlyUnit"
                                            checked={
                                                unit == "hourly"
                                                    ? "checked"
                                                    : ""
                                            }
                                            name="unit"
                                            value={"hourly"}
                                            onChange={(e) =>
                                                setUnit(e.target.value)
                                            }
                                        />
                                        <span className="checkmark">
                                            <span className="dot"></span>
                                            Hourly
                                        </span>
                                    </label>
                                    <label
                                        className="how_often_container"
                                        htmlFor="weeklyUnit"
                                    >
                                        <input
                                            type="radio"
                                            id="weeklyUnit"
                                            checked={
                                                unit == "weekly"
                                                    ? "checked"
                                                    : ""
                                            }
                                            name="unit"
                                            value={"weekly"}
                                            onChange={(e) =>
                                                setUnit(e.target.value)
                                            }
                                        />
                                        <span className="checkmark">
                                            <span className="dot"></span>
                                            Weekly
                                        </span>
                                    </label>
                                    <label
                                        className="how_often_container"
                                        htmlFor="monthlyUnit"
                                    >
                                        <input
                                            type="radio"
                                            id="monthlyUnit"
                                            checked={
                                                unit == "monthly"
                                                    ? "checked"
                                                    : ""
                                            }
                                            name="unit"
                                            value={"monthly"}
                                            onChange={(e) =>
                                                setUnit(e.target.value)
                                            }
                                        />
                                        <span className="checkmark">
                                            <span className="dot"></span>
                                            Monthly
                                        </span>
                                    </label>
                                </div>
                            </div> */}
                            {/* <div className="form-group week_days">
                                <label>
                                    How often do you need this service?
                                </label>
                                <br />
                                <label className="days-container">
                                    <input
                                        type="checkbox"
                                        checked="checked"
                                        name="dayss"
                                    />
                                    <span className="checkmark">
                                        <div className="days">
                                            <span>Mon</span>
                                        </div>
                                    </span>
                                </label>
                                <label className="days-container">
                                    <input type="checkbox" name="dayss" />
                                    <span className="checkmark">
                                        <div className="days">
                                            <span>Tue</span>
                                        </div>
                                    </span>
                                </label>
                                <label className="days-container">
                                    <input type="checkbox" name="dayss" />
                                    <span className="checkmark">
                                        <div className="days">
                                            <span>Wed</span>
                                        </div>
                                    </span>
                                </label>
                                <label className="days-container">
                                    <input type="checkbox" name="dayss" />
                                    <span className="checkmark">
                                        <div className="days">
                                            <span>Thurs</span>
                                        </div>
                                    </span>
                                </label>
                                <label className="days-container">
                                    <input type="checkbox" name="dayss" />
                                    <span className="checkmark">
                                        <div className="days">
                                            <span>Fri</span>
                                        </div>
                                    </span>
                                </label>
                                <label className="days-container">
                                    <input type="checkbox" name="dayss" />
                                    <span className="checkmark">
                                        <div className="days">
                                            <span>Sat</span>
                                        </div>
                                    </span>
                                </label>
                                <label className="days-container">
                                    <input type="checkbox" name="dayss" />
                                    <span className="checkmark">
                                        <div className="days">
                                            <span>Sun</span>
                                        </div>
                                    </span>
                                </label>
                            </div> */}
                            <div className="form-group">
                                <label>Select the Dates</label>
                                <div className="input-group">
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={dateRangeFrom}
                                        onChange={(e) =>
                                            setDateRangeFrom(e.target.value)
                                        }
                                    />
                                    <div className="spacer">-</div>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={dateRangeTo}
                                        onChange={(e) =>
                                            setDateRangeTo(e.target.value)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="button-group">
                                <button
                                    className="btn"
                                    onClick={() => Navigate("/")}
                                >
                                    Cancel
                                </button>
                                <button className="btn" id="done-form">
                                    Find a Care Giver
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* <!-- Services Popup1 End Here --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    services: state.services,
});

const mapDispatchToProps = (disaptch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CareGiverNew);
